var exports = {
  "Im": "comment__7cxL1H",
  "NP": "commentHeader__kM203G",
  "fh": "authorName__YxLWrD",
  "vE": "timestamp__oL107m",
  "I2": "commentBody__xm2GIG",
  "WA": "commentLine__KqWr-Y",
  "qr": "footer__RP6QJ9",
  "fC": "repliesButton__aeK_RX",
};

module.exports = exports;
